export default __webpack_public_path__ + "static/media/dashboardInvitations.064c321b.svg";